import { render, staticRenderFns } from "./notif_modal.vue?vue&type=template&id=2f61ebc0&scoped=true&"
import script from "./notif_modal.vue?vue&type=script&lang=js&"
export * from "./notif_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f61ebc0",
  null
  
)

export default component.exports